<template>
  <div class="chart-container" style="height: 260px;">
    <canvas ref="canvasRef" />
  </div>
</template>

<script>
import { defineComponent, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { Chart } from 'chart.js';
import { CHART_COLORS } from '../chartSpec.js';

export default defineComponent({
  name: 'PieChart',
  props: {
    spec: { type: Object, required: true },
  },
  setup(props) {
    const canvasRef = ref(null);
    let chart = null;

    function buildConfig() {
      return {
        type: 'doughnut',
        data: {
          labels: props.spec.data.map((d) => d.label),
          datasets: [
            {
              data: props.spec.data.map((d) => d.value),
              backgroundColor: props.spec.data.map((_, i) => CHART_COLORS[i % CHART_COLORS.length]),
              borderWidth: 0,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          // `pie` is a solid circle (cutout=0); `donut` gets a hole.
          cutout: props.spec.type === 'pie' ? '0%' : '55%',
          plugins: {
            legend: {
              position: 'right',
              labels: {
                font: { size: 11 },
                boxWidth: 12,
                padding: 8,
              },
            },
            tooltip: {
              backgroundColor: 'rgba(17, 24, 39, 0.92)',
              padding: 8,
              cornerRadius: 6,
              titleFont: { size: 12 },
              bodyFont: { size: 12 },
              callbacks: {
                label: (ctx) => {
                  const total = ctx.dataset.data.reduce((a, b) => a + b, 0);
                  const pct = total > 0 ? Math.round((ctx.parsed / total) * 100) : 0;
                  return `${ctx.label}: ${ctx.parsed} (${pct}%)`;
                },
              },
            },
          },
        },
      };
    }

    onMounted(() => {
      if (canvasRef.value) {
        chart = new Chart(canvasRef.value.getContext('2d'), buildConfig());
      }
    });

    watch(
      () => props.spec,
      () => {
        if (!chart) return;
        const cfg = buildConfig();
        chart.data = cfg.data;
        chart.options = cfg.options;
        chart.update();
      },
      { deep: true },
    );

    onBeforeUnmount(() => {
      if (chart) {
        chart.destroy();
        chart = null;
      }
    });

    return { canvasRef };
  },
});
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
}
</style>
